document.addEventListener('DOMContentLoaded', () => {
  const counter = document.getElementById('ProductGridContainer');
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
     main();
    });
  });
  observer.observe(counter, { childList: true });

  const main = () => {
    const labels = document.querySelectorAll('third-party-nmp-card');
    labels.forEach((item) => {
      let { price, months } = item.dataset;
      if (!months) return;
      price = Number(price) / 100;
      months = Number(months);
      const monthlyPrice = (price / months).toFixed(0);
      const formatedPrice = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        roundingIncrement: 1,
      }).format(monthlyPrice);
      item.innerHTML = `$${formatedPrice.replace(
        '$',
        ''
      )}/ mes por ${months} meses`;
    });
  };
  main();
});
